import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/components/Elements/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/comps/EstimatedRead.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/comps/NewsLayoutClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarSearch","SidebarItem"] */ "/app/comps/NewsSidebarClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/comps/YearItem.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1-canary.44_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@types+node@22.19.19_react-_rxnoxritl4o42jq2ibodbf454e/node_modules/next/dist/client/app-dir/link.js");
